import templateUrl from './app-menu.html';

export default {
  templateUrl,
  bindings: {
    currentUser: '<'
  },
  controller: class MenuComponent {
    constructor($location, $mdMedia, $mdSidenav, AuthService) {
      'ngInject';

      Object.assign(this, {
        $location,
        $mdMedia,
        $mdSidenav,
        AuthService
      });
    }

    $onInit() {
      this.navLinks = [{
        state: 'dashboard',
        sref: 'dashboard',
        description: 'Dashboard',
        keywords: ['dashboard'],
        icon: 'fa-home'
      }, {
        state: 'account',
        sref: 'account',
        description: 'Manage Account',
        keywords: ['account'],
        icon: 'fa-gear'
      }, {
        state: 'company',
        sref: `company({id: ${this.currentUser.MemberId}})`,
        description: 'Manage Account',
        keywords: ['companies'],
        icon: 'fa-gear'
      }, {
        state: 'companies',
        sref: 'companies',
        description: 'Manage Accounts',
        keywords: ['companies', 'regulators'],
        icon: 'fa-gear'
      }, {
        state: 'products',
        sref: 'products',
        description: 'Manage Products',
        keywords: ['products'],
        icon: 'fa-leaf'
      }, {
        state: 'adverseEvents',
        sref: 'adverseEvents',
        description: 'Manage Adverse Events',
        keywords: ['adverse-events'],
        icon: 'fa-pencil-square-o'
      }, {
        state: 'userIngredients',
        sref: 'userIngredients',
        description: 'User Ingredients',
        keywords: ['user-ingredients'],
        icon: 'fa-user'
      }, {
        state: 'systemIngredients',
        sref: 'systemIngredients',
        description: 'System Ingredients',
        keywords: ['system-ingredients'],
        icon: 'fa-hdd-o'
      }, {
        state: 'mapIngredients',
        sref: 'mapIngredients',
        description: 'Map Ingredients',
        keywords: ['map-ingredients'],
        icon: 'fa-sitemap fa-rotate-90'
      }, {
        state: 'categories',
        sref: 'categories',
        description: 'Categories',
        keywords: ['/categories'],
        icon: 'fa-tags'
      }, {
        state: 'mapCategories',
        sref: 'mapCategories',
        description: 'Map Categories',
        keywords: ['map-categories'],
        icon: 'fa-sitemap fa-rotate-90'
      }, {
        state: 'memberCompliance',
        sref: 'memberCompliance',
        description: 'Member Compliance',
        keywords: ['member-compliance'],
        icon: 'fa-id-card-o'
      }, {
        state: 'reports',
        sref: 'reports',
        description: 'Reports',
        keywords: ['reports'],
        icon: 'fa-bar-chart-o'
      }];

      if (this.AuthService.isSysAdmin) {
        this.navLinks = this.navLinks.filter(l => l.state !== 'company');
      }
    }

    get welcomeMessage() {
      if (this.currentUser.FirstName) {
        return `Welcome, ${this.currentUser.FirstName}!`;
      }

      return 'Welcome!';
    }

    toggleIfOpenUnlocked() {
      const isLockedOpen = this.$mdSidenav('left').isLockedOpen();

      if (isLockedOpen === false) {
        this.$mdSidenav('left').toggle();
      }
    }

    isActive(navLink) {
      return navLink.keywords.some(k => this.$location.path().toLowerCase().indexOf(k) > -1);
    }

    logout() {
      this.AuthService.logout();
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/app-menu/app-menu.component.js